import { render, staticRenderFns } from "./ConsentStatusCard.vue?vue&type=template&id=6741f15c&scoped=true"
import script from "./ConsentStatusCard.vue?vue&type=script&lang=ts"
export * from "./ConsentStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./ConsentStatusCard.vue?vue&type=style&index=0&id=6741f15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741f15c",
  null
  
)

export default component.exports